// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wZASG","title":"styles_title__2nX9H"};